export function MediaZeroState({
  title,
  description,
}: {
  title: string;
  description?: string;
}) {
  return (
    <div className="flex h-full w-full items-center justify-center gap-y-5 bg-zi-gray">
      <p className="text-[34px] font-semibold leading-10 tracking-[1px]">
        {title}
      </p>
      <p className="text-[18px] font-normal leading-[31px] empty:hidden">
        {description}
      </p>
    </div>
  );
}
